<template>
  <div class="navbar-filters-part">
    <CasesFilters v-if="casesRouteNames.indexOf($route.name) != -1" />
    <OrdersFilters v-if="orderRouteNames.indexOf($route.name) != -1" />
    <EmrFilters v-if="emrRouteNames.indexOf($route.name) != -1" />
    <BillingFilters v-if="billingRouteNames.indexOf($route.name) != -1" />
    <ResultFilters v-if="resultRouteNames.indexOf($route.name) != -1" />
    <PhysicianFilters v-if="physicianRouteNames.indexOf($route.name) != -1" />
    <HospitalFilters v-if="hospitalRouteNames.indexOf($route.name) != -1" />
    <ApprovalPendingCasesFilters
      v-if="pendingCasesRouteNames.indexOf($route.name) != -1"
    />
    <QCChartFilters v-if="qcchartRouteNames.indexOf($route.name) != -1" />
    <SendOutsFilters v-if="sendOutRouteNames.indexOf($route.name) != -1" />
    <ReceivedSendOutsFilters
      v-if="receivedSendOutRouteNames.indexOf($route.name) != -1"
    />
    <ResultFileFilters
      v-if="resultFileViewProgressRouteNames.indexOf($route.name) != -1"
    />
    <UserAccountsFilters
      v-if="userAccountRouteNames.indexOf($route.name) != -1"
    />

    <ArchiveFilters v-if="archiveRouteNames.indexOf($route.name) != -1" />
    <GenedFilters v-if="genedRouteName.indexOf($route.name) != -1" />
    <BulkAccessionFilters
      v-if="bulkAccessionRouteName.indexOf($route.name) != -1"
    />
    <LogsFilters v-if="logsRouterName.indexOf($route.name) != -1" />
    <LabdaqFilters v-if="labdaqRouteNames.indexOf($route.name) != -1" />
    <ValidationCases
      v-if="validationCasesRouteNames.indexOf($route.name) != -1"
    />
    <ValidationOrders
      v-if="validationOrdersRouteNames.indexOf($route.name) != -1"
    />
    <ValidationEMROrders
      v-if="validationEMROrdersRouteNames.indexOf($route.name) != -1"
    />
    <BilledFilters v-if="billedRouteNames.indexOf($route.name) != -1" />
    <PhlebioFilter v-if="phlebioRouteNames.indexOf($route.name) != -1" />
    <BillingRuleBookFilter v-if="billingRuleBookRouteNames.indexOf($route.name) != -1" />

  </div>
</template>

<script>
import CasesFilters from "@/components/navbarFilter/CaseFilter";
import OrdersFilters from "@/components/navbarFilter/OrderFilter";
import EmrFilters from "@/components/navbarFilter/EmrFilter";
import BillingFilters from "@/components/navbarFilter/BillingFilter";
import ResultFilters from "@/components/navbarFilter/ResultFilter";
import PhysicianFilters from "@/components/navbarFilter/PhysicianFilter";
import HospitalFilters from "@/components/navbarFilter/HospitalFilter";
import ApprovalPendingCasesFilters from "@/components/navbarFilter/ApprovalPendingCasesFilter";
import QCChartFilters from "@/components/navbarFilter/QCChartFilter";
import SendOutsFilters from "@/components/navbarFilter/SendOutsFilter";
import ReceivedSendOutsFilters from "@/components/navbarFilter/ReceivedSendOutsFilter";
import ResultFileFilters from "@/components/navbarFilter/ResultFilesFilter";
import UserAccountsFilters from "@/components/navbarFilter/UserAccountsFilter";
import ArchiveFilters from "@/components/navbarFilter/ArchiveFilter";
import GenedFilters from "@/components/navbarFilter/GenedFilter";
import BulkAccessionFilters from "@/components/navbarFilter/BulkAccession";
import LogsFilters from "@/components/navbarFilter/LogsFilter";
import LabdaqFilters from "@/components/navbarFilter/LabdaqFilter";
import ValidationCases from "@/components/navbarFilter/ValidationCases";
import ValidationOrders from "@/components/navbarFilter/ValidationOrders";
import ValidationEMROrders from "@/components/navbarFilter/ValidationEMROrders";
import BilledFilters from "@/components/navbarFilter/BilledFilter";
import PhlebioFilter from "@/components/navbarFilter/PhlebioFilter.vue";
import BillingRuleBookFilter from "@/components/navbarFilter/BillingRuleBookFilter";

export default {
  components: {
    CasesFilters,
    OrdersFilters,
    EmrFilters,
    BillingFilters,
    ResultFilters,
    PhysicianFilters,
    HospitalFilters,
    ApprovalPendingCasesFilters,
    QCChartFilters,
    SendOutsFilters,
    ReceivedSendOutsFilters,
    ResultFileFilters,
    UserAccountsFilters,
    ArchiveFilters,
    GenedFilters,
    BulkAccessionFilters,
    LogsFilters,
    LabdaqFilters,
    ValidationCases,
    ValidationOrders,
    ValidationEMROrders,
    BilledFilters,
    PhlebioFilter,
    BillingRuleBookFilter
  },
  data() {
    return {
      casesRouteNames: [
        "AllCases",
        "CaseView",
        "ActiveCases",
        "PendingCases",
        "CompleteCases",
        "ArchiveCase",
        "Case-Information-Update",
        "Concurrent-Case-Information-Update",
        "NewReportCases",
        "EMRNotSend",
        "CriticalCases",
        "PendingCasesList",
        "RejectedCases",
        "ReleasePending",
        "ReplacedInsurance"
      ],
      orderRouteNames: [
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
        "ArchiveOrders",
        "Order-Information",
        "Edit-Order-Info",
        "PartialOrders",
        "RejectionOrders",
        "PendingOrders",
        "ClientPendingOrder",
      ],
      emrRouteNames: [
        "AllEMROrders",
        "ActiveEMROrders",
        "PendingEMROrders",
        "CompleteEMROrders",
        "ArchiveEMROrders",
        "View-Case-Information",
        "Finalized-Reports",
        "View-Configuration",
        "PartialEMROrders",
        "NotSentEMROrders",
        "EMROrdersWithIssues"
      ],
      billingRouteNames: [
        "AllBillingCase",
        "ActiveBillingCase",
        "PendingBillingCase",
        "CompleteBillingCase",
        "AddBillingCase",
      ],
      resultRouteNames: [
        "allResults",
        "ActiveResults",
        "ToStartResults",
        "CompleteResults",
        "ArchiveResults",
        "ProcessingResults",
        "FailedResults",
        "allResultsFileUpload",
      ],
      physicianRouteNames: [
        "AllPhysicians",
        "ActivePhysicians",
        "InActivePhysicians",
        "AddNewPhysician",
        "PhysicianProfileView",
        "PhysicianEdit",
      ],
      hospitalRouteNames: [
        "AllHospitals",
        "ActiveHospitals",
        "InActiveHospitals",
        "Hospital-Primary-Information",
        "NewHospital",
        "Branches-List",
        "HospitalPhysicians",
        "HospitalAccountManagers",
        "HospitalAdmins",
        "Add-Branch",
        "EditAccountManager",
        "EditHospitalAdmin",
        "Edit-Branch",
        "EditHospitalPhysician",
      ],
      userAccountRouteNames: [
        "userAccounts",
        "ActiveUserAccounts",
        "InActiveUserAccounts",
        "addUser",
        "EditUserAccount",
      ],
      pendingCasesRouteNames: [
        "AllApprovalPendingCases",
        "ActiveApprovalPendingCases",
        "PendingApprovalPendingCases",
        "CompleteApprovalPendingCases",
        "RejectedApprovalPendingCases",
        "PendingCaseView",
        "PendingCasesEdit",
      ],
      qcchartRouteNames: [
        "QCChatResults",
        "ToStartQCChartResults",
        "CompleteQCChartResults",
        "QCChartFileUpload",
      ],
      sendOutRouteNames: [
        "allSendOuts",
        "ActiveSendOuts",
        "PendingSendOuts",
        "CompleteSendOuts",
        "SendoutsInformation",
        "SendOutsEdit",
        "SendOutsView",
        "ArchiveSendouts",
      ],
      receivedSendOutRouteNames: [
        "allReceivedSendOuts",
        "ActiveReceivedSendOuts",
        "CompleteReceivedSendOuts",
        "ReceivedSendOutView",
      ],
      resultFileViewProgressRouteNames: [
        "viewprogress",
        "ToStartResultFilesViewProgress",
        "ProcessingResultFilesViewProgress",
        "FailedResultFilesViewProgress",
        "CompletedResultFiles",
      ],
      archiveRouteNames: ["ArchiveDataCases", "ArchiveDataOrders"],
      genedRouteName: [
        "ReportsList",
        "PulmonaryReportsList",
        "viewGenedTestResults",
        "addGenedTestResults",
      ],
      bulkAccessionRouteName: [
        "allBulkAccession",
        "failedBulkAccession",
        "completeBulkAccession",
      ],
      logsRouterName: [
        "casesLogs",
        "ordersLogs",
        "emrOrdersLogs",
        "resultFileLogs",
        "generalLogs",
      ],

      labdaqRouteNames: [
        "LabdaqPendingOrders",
        "LabdaqPendingResults",
        "LabdaqInvalidOrders",
        "LabdaqCompletedOrders",
      ],
      billedRouteNames: [
        "AllPendingBilledCases",
        "BilledCases",
        "ClientBilledCases",
        "ExceptionBilledCases",
        "OnholdBilledCases",
        "BilledExceptionBilledCases",
        "BilledPatientBilledCases",
        "CodingCases",
        "MileageCases",
        "ExceptionResolvedCases",
        "ExceptionReviewedCases",
      ],
      validationCasesRouteNames: [
        "ValidationCases",
        "ActiveValidationCases",
        "PendingValidationCases",
        "CompleteValidationCases",
        "ArchiveValidationCases",
      ],
      validationOrdersRouteNames: [
        "ValidationOrders",
        "ActiveValidations",
        "CompleteValidations",
        "ArchiveValidations",
      ],
      validationEMROrdersRouteNames: [
        "ValidationEMROrders",
        "ActiveValidationEMROrders",
        "ArchiveValidationEMROrders",
        "CompleteValidationEMROrders",
      ],
      phlebioRouteNames: [
        "AllPhlebioOrders",
        "AllPhlebioRequests",
        "PhlebioOrderDetails",
        "EditPhlebioOrderDetails",
        "PhlebioEMROrders",
        "PhlebioLabsquireOrders"
    ],
      billingRuleBookRouteNames: [
        "AllCodingRules",
        "AllClaim",
        "AllARRules",
        "PaymentRules",
        "PateintRules",
        "AddRules",
        "UpdatedRules",
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.navbar-filters-part {
  .filters-list {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    margin-top: 0 !important;

    li {
      z-index: 999;

      &:not(:last-child) {
        margin-right: 5px;
        @media (min-width: 1200px) and (max-width: 1400px) {
          margin-right: 0;
        }
      }
    }
    a {
      color: #888383;
      font-weight: 500;
      font-size: 13px;
      display: block;
      padding: 5px 7px;

      transition: all 0.2s ease-in-out;
      &:hover {
        color: #273480;
      }
      @media (min-width: 1200px) and (max-width: 1400px) {
        font-size: 13px;
        padding: 5px 8px;
      }
    }
    .active-icon {
      display: none;
    }

    // router-link-active
    .router-link-active,
    .router-link-active-parent > a {
      position: relative;
      color: #273480;
      opacity: 1;
      font-weight: 500;
      z-index: 1;
      .active-icon {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: translateX(40%);
        transition: all 5s ease;
        z-index: -1;
        img {
          margin-bottom: -13px;
        }
        img:first-child {
          margin-left: -2px;
        }
      }
    }
  }
}
</style>
